import { render, staticRenderFns } from "./CourseLevel.vue?vue&type=template&id=770fa454"
import script from "./CourseLevel.vue?vue&type=script&lang=js"
export * from "./CourseLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports